module.exports = function () {
    var $lottieFiles = $('[data-lottie-src]');

    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

    var lottieIeFixer = function (el) {
        if (!isIE11) {
            return;
        }

        var width = el.clientWidth;
        var svg = el.querySelector('svg');

        var ratio = width / svg.width.baseVal.value;

        var newWidth = width + 'px';
        var newHeight = (svg.height.baseVal.value * ratio) + 'px';

        svg.style.width = newWidth;
        svg.style.height = newHeight;
    };

    var isInViewport = function (el) {
        var bounding = el.getBoundingClientRect();
        var isTallerThanViewport = bounding.height > window.innerHeight;
        var isInBounds = false;
        if (isTallerThanViewport) {
            isInBounds = (bounding.top <= window.innerHeight / 2 && bounding.left >= 0 && bounding.right <= window.innerWidth && bounding.bottom > window.innerHeight);
        } else {
            isInBounds = (bounding.top >= 0 && bounding.left >= 0 && bounding.right <= window.innerWidth && bounding.bottom <= window.innerHeight);
        }
        return isInBounds;
    };

    $lottieFiles.each(function () {
        var $lottieFile = $(this);
        var el = $lottieFile[0];
        var path = $lottieFile.data('lottieSrc');

        var animation = lottie.loadAnimation({
            container: el,
            renderer: 'svg',
            loop: true,
            autoplay: false,
            path: path
        });

        animation.addEventListener('data_ready', function () {
            if (isInViewport(el)) {
                animation.play();
            }
            else {
                var hasPlayed = false;

                $(window).scroll(function () {
                    if (!hasPlayed) {
                        if (isInViewport(el)) {
                            animation.play();
                            hasPlayed = true;
                        }
                    }
                });
            }
        });

        if (isIE11) {
            animation.addEventListener('DOMLoaded', function () {
                lottieIeFixer(el);
            });

            $(window).resize(function () {
                requestAnimationFrame(function () {
                    lottieIeFixer(el);
                });
            });
        }
    });
};